/*************************************************************************
* Copyright (c) 2025 Omnineura AI Technologies Pvt Limited.
* All rights reserved.
* This code is licensed under the 'Omnineura AI License' found in the LICENSE file.
* Unauthorized copying, sharing, or use of this code is prohibited.
* The intellectual and technical concepts are proprietary to Omnineura AI Technologies Pvt Limited.
* Author: surya@Omnineura.ai
* Date: 11-09-2025
*************************************************************************/

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { activateKnowledgeBaseApi, createKnowledgeBaseApi, getAllKnowledgeBaseApi , getActiveKnowledgeBaseApi, deleteKnowledgeBaseApi} from "../services/api";

// Async thunk
export const createKnowledgeBase = createAsyncThunk(
  "knowledgeBases/create",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
        
      const response = await createKnowledgeBaseApi(payload);
      
      dispatch(getAllKnowledgeBase())
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to create KB");
    }
  }
);

//list of all knowledge bases
export const getAllKnowledgeBase = createAsyncThunk(
  "knowledgeBases/documents", async (__, { rejectWithValue }) => {

    try {
     
      const response = await getAllKnowledgeBaseApi();
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to create KB");
    }

  })

//activating knowledgebase
export const activateKnowledgeBase = createAsyncThunk(
  "knowledgeBase/activate", async (name, { rejectWithValue }) => {

    try {
      // const token = getState().auth.token;
      const response = await activateKnowledgeBaseApi({ name });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to fetch Knowledgebase");
    }

  }
)

export const fetchActiveKnowledgeBase = createAsyncThunk(
  "knowledgeBases/fetchActive",
  async () => {
    const data = await getActiveKnowledgeBaseApi();
    return data;
  }
);

export const deleteKnowledgeBase = createAsyncThunk(
  "knowledgeBases/delete",
  async (collection_name, { rejectWithValue }) => {
    try {
      const response = await deleteKnowledgeBaseApi(collection_name);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to delete KB");
    }
  }
);

const knowledgeBaseReducer = createSlice({
  name: "knowledgeBases",
  initialState: {
    items: [],
    loading: false,
    error: null,
    activeCollection: null,
    uiSelectedKnowledgeBase: null, // <- frontend/UI state
  },
  reducers: {
    setUiSelectedKnowledgeBase: (state, action) => {
    
      state.uiSelectedKnowledgeBase = action.payload;
    },
    clearUiSelectedKnowledgeBase: (state) => {
      state.uiSelectedKnowledgeBase = null;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(createKnowledgeBase.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createKnowledgeBase.fulfilled, (state, action) => {
        state.loading = false;
        state.items.push({
          ...action.payload,
          color: [

            "bg-red-500",

          ][state.items.length % 8], // cycle through colors
        });

      })
      .addCase(createKnowledgeBase.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getAllKnowledgeBase.fulfilled, (state, action) => {
       
        state.items = action.payload.data.collections; // replace entire list
      })
      .addCase(activateKnowledgeBase.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(activateKnowledgeBase.fulfilled, (state, action) => {
        state.loading = false;
        
        state.activeCollection = action.payload.data.active_collection;
        
      })
      .addCase(activateKnowledgeBase.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchActiveKnowledgeBase.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchActiveKnowledgeBase.fulfilled, (state, action) => {
        state.loading = false;
        
        state.activeCollection = action.payload.data.active_collection;
        
      })
      .addCase(fetchActiveKnowledgeBase.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteKnowledgeBase.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteKnowledgeBase.fulfilled, (state, action) => {
        state.loading = false;
        state.items = state.items?.filter(item => item.name !== action.payload.data.collection_name);
      })
      .addCase(deleteKnowledgeBase.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setUiSelectedKnowledgeBase,
  clearUiSelectedKnowledgeBase
} = knowledgeBaseReducer.actions;
export default knowledgeBaseReducer.reducer;
